import { QUICK, SHOPPING_CART } from '~/hooks/useCartTypeParam';

export const RECOMMEND_CHECKOUT_SHOPPING_CART = `/recommend?cartType=${SHOPPING_CART}`;

export const RECOMMEND_CHECKOUT_NEW_SHOPING_CART = `/recommend/new?cartType=${SHOPPING_CART}`;
export const RECOMMEND_CHECKOUT_QUICK = `/recommend?cartType=${QUICK}`;

export const CHECKOUT_SHOPPING_CART = `/checkout?cartType=${SHOPPING_CART}`;
export const CHECKOUT_QUICK = `/checkout?cartType=${QUICK}`;
export const E_COUPON_CHECKOUT = `/e-coupon/checkout`;
